import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-h5 font-weight-bold" }, "Logging you in..", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_EmailPrompt = _resolveComponent("EmailPrompt")!
  const _component_v_stepper_window_item = _resolveComponent("v-stepper-window-item")!
  const _component_PasswordPrompt = _resolveComponent("PasswordPrompt")!
  const _component_ResendPrompt = _resolveComponent("ResendPrompt")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_stepper_window = _resolveComponent("v-stepper-window")!
  const _component_v_stepper = _resolveComponent("v-stepper")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fill-height overflow-x-hidden", _ctx.smAndDown ? 'background-mob' : 'background']),
    style: _normalizeStyle(`background-image: ${_ctx.splash}`)
  }, [
    _createVNode(_component_v_row, { class: "ma-0 fill-height" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              justify: "start",
              class: "position-fixed"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "auto" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: _ctx.landscapeLogoSrc,
                      width: _ctx.smAndDown ? 200 : 250,
                      "max-width": _ctx.smAndDown ? 200 : 250,
                      class: "py-2 mx-2 float-right"
                    }, null, 8, ["src", "width", "max-width"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              class: "fill-height",
              justify: "center",
              align: "center",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_stepper, {
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.activeStep = $event)),
                      "model-value": _ctx.activeStep,
                      flat: "",
                      class: "my-auto",
                      id: "login-stepper",
                      onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.error = '')),
                      "min-width": "400"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_stepper_window, { "model-value": _ctx.activeStep }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_stepper_window_item, {
                              value: _ctx.LoginSteps.EmailPrompt,
                              class: "fill-height"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  class: "fill-height",
                                  justify: "center",
                                  align: "center",
                                  "no-gutters": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_EmailPrompt, {
                                          onCheckEmail: _cache[0] || (_cache[0] = ($event: any) => {_ctx.username = $event; _ctx.checkUser();}),
                                          loading: _ctx.loading,
                                          error: _ctx.error,
                                          onClearError: _cache[1] || (_cache[1] = ($event: any) => (_ctx.error = '')),
                                          "query-username": _ctx.username
                                        }, null, 8, ["loading", "error", "query-username"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            _createVNode(_component_v_stepper_window_item, {
                              value: _ctx.LoginSteps.PasswordPrompt,
                              class: "fill-height"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  class: "fill-height",
                                  justify: "center",
                                  align: "center",
                                  "no-gutters": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_PasswordPrompt, {
                                          activated: _ctx.activated,
                                          error: _ctx.error,
                                          "query-code": _ctx.queryCode,
                                          onClearError: _cache[2] || (_cache[2] = ($event: any) => (_ctx.error = '')),
                                          onGoToEmail: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeStep = _ctx.LoginSteps.EmailPrompt)),
                                          onCheckPassword: _cache[4] || (_cache[4] = ($event: any) => {_ctx.password = $event; _ctx.login()}),
                                          onGoToForgotPassword: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeStep = _ctx.LoginSteps.ForgotPassword)),
                                          onGoToResendRegistration: _cache[6] || (_cache[6] = ($event: any) => (_ctx.activeStep = _ctx.LoginSteps.ResendRegistration))
                                        }, null, 8, ["activated", "error", "query-code"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            _createVNode(_component_v_stepper_window_item, {
                              value: _ctx.LoginSteps.NewPasswordPrompt,
                              class: "fill-height"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  class: "fill-height",
                                  justify: "center",
                                  align: "center",
                                  "no-gutters": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_PasswordPrompt, {
                                          error: _ctx.error,
                                          onClearError: _cache[7] || (_cache[7] = ($event: any) => (_ctx.error = '')),
                                          onGoToEmail: _cache[8] || (_cache[8] = ($event: any) => (_ctx.activeStep = _ctx.LoginSteps.EmailPrompt)),
                                          onCheckPassword: _cache[9] || (_cache[9] = ($event: any) => {_ctx.password = $event; _ctx.login()}),
                                          loading: _ctx.loading,
                                          activated: _ctx.activated,
                                          "is-new": _ctx.isNew
                                        }, null, 8, ["error", "loading", "activated", "is-new"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            _createVNode(_component_v_stepper_window_item, {
                              value: _ctx.LoginSteps.ForgotPassword,
                              class: "fill-height"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  class: "fill-height",
                                  justify: "center",
                                  align: "center",
                                  "no-gutters": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ResendPrompt, {
                                          username: _ctx.username,
                                          "onGoTo:email": _cache[10] || (_cache[10] = ($event: any) => (_ctx.activeStep = _ctx.LoginSteps.EmailPrompt))
                                        }, null, 8, ["username"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            _createVNode(_component_v_stepper_window_item, {
                              value: _ctx.LoginSteps.ResendRegistration,
                              class: "fill-height"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  class: "fill-height",
                                  justify: "center",
                                  align: "center",
                                  "no-gutters": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ResendPrompt, {
                                          username: _ctx.username,
                                          activating: true,
                                          "onGoTo:email": _cache[11] || (_cache[11] = ($event: any) => (_ctx.activeStep = _ctx.LoginSteps.EmailPrompt))
                                        }, null, 8, ["username"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            _createVNode(_component_v_stepper_window_item, {
                              value: _ctx.LoginSteps.Loading,
                              class: "fill-height"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  class: "fill-height",
                                  justify: "center",
                                  align: "center",
                                  "no-gutters": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, {
                                          justify: "center",
                                          align: "center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              md: "5",
                                              class: "pa-4"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card, {
                                                  color: "background",
                                                  class: "px-4 py-6"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      "no-gutters": "",
                                                      align: "center",
                                                      justify: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          class: "text-center"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_1
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_col, {
                                                          cols: "auto",
                                                          class: "mt-6"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_progress_circular, {
                                                              indeterminate: "",
                                                              color: "primary"
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["model-value"])
                      ]),
                      _: 1
                    }, 8, ["model-value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 6))
}